import { Spacing, SpacingSizes } from "@components/Spacing";
import { H3, Title1 } from "@components/Typography";
import { useProjectedChart } from "@hooks";
import { Translations, i18n } from "@i18n";
import { formatCurrency } from "@utils";
import { GoalTypeButton } from "./GoalTypeButton";
import { RateOfReturn } from "./RateOfReturn";
import { useStyles } from "./styles";
import { ChartHeaderProps } from "./types";

export const ChartHeader = ({
  title = i18n.t(Translations.ProjectedChartHeaderTitle),
}: ChartHeaderProps) => {
  const styles = useStyles();

  const { projectedAmount } = useProjectedChart();

  const targetAmount = formatCurrency(projectedAmount);

  return (
    <div>
      <div style={styles.container}>
        <H3 style={styles.text}>{title}</H3>
        <GoalTypeButton />
      </div>
      <Title1 style={styles.amount}>{targetAmount}</Title1>
      <Spacing size={SpacingSizes.XS} />

      <RateOfReturn />
      <Spacing size={SpacingSizes.XS} />
    </div>
  );
};
